import { useMutation } from '@tanstack/react-query';
import { InstagramAudio } from '@round/api';
import { findOrCreateInstagramAudio } from 'Modules/Instagram/Instagram.helpers';

export function useFindOrCreateInstagramAudio() {
    const { mutateAsync, isPending, error } = useMutation<InstagramAudio, Error, string>({
        mutationFn: async (url: string) => {
            const result = await findOrCreateInstagramAudio(url);
            if (!result.success) {
                throw new Error(result.error);
            }
            return result.data;
        },
    });

    return { findOrCreate: mutateAsync, isLoading: isPending, error };
}
